import { BodyNormal, ExternalLink, H4 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { TEST_ID } from '../../../../../constants';
import { TaglineContainer } from './styles';
const UnofficialSupport = _ref => {
  let {
    supportDetails,
    atlassianCommunityUrl,
    onCommunityLinkClick
  } = _ref;
  if (supportDetails.hasResources) {
    return /*#__PURE__*/React.createElement(BodyNormal, null, "Below are the basic resources shared by the partner through which you can seek assistance in case of any need.");
  }
  return /*#__PURE__*/React.createElement(BodyNormal, null, "If you have any concern or query,", ' ', /*#__PURE__*/React.createElement(ExternalLink, {
    href: atlassianCommunityUrl,
    size: "medium",
    onClick: onCommunityLinkClick
  }, "engage with Atlassian Community"), ' ', "where other customers discuss about apps.");
};
export const SupportTagline = props => {
  const {
    supportDetails: {
      isSupported,
      partner: {
        name: partnerName
      },
      contact: {
        issueTrackerUrl,
        supportTicketSystemUrl,
        emailId
      }
    },
    atlassianCommunityUrl,
    onCommunityLinkClick
  } = props;
  const hasOfficialSupport = partnerName && isSupported && (issueTrackerUrl || supportTicketSystemUrl || emailId);
  return /*#__PURE__*/React.createElement(TaglineContainer, {
    "data-testid": TEST_ID.SUPPORT_TAB_SUPPORT_TAGLINE
  }, /*#__PURE__*/React.createElement(H4, {
    as: "h2"
  }, hasOfficialSupport ? "".concat(partnerName, " provides support for this version of the app") : "".concat(partnerName || 'The partner', " does not provide support for this version of the app")), !hasOfficialSupport && /*#__PURE__*/React.createElement(UnofficialSupport, {
    supportDetails: props.supportDetails,
    atlassianCommunityUrl: atlassianCommunityUrl,
    onCommunityLinkClick: onCommunityLinkClick
  }));
};